module.exports = __webpack_public_path__ + "static/media/sort-up.98c33bbd.png";